<template>
    <div >
        <highcharts class="hc" :options="chartOptions"></highcharts>
    </div>
</template>
<script>
export default{
    data(){
        return{
            selectOptions: ['Last 7 Days','15 Days','30 Days','3 Months','6 Months','12 Months','Custom Range'],
            selectedStatusCode: 'Last 7 Days',
            fromDate: '25 may, 2021',
            toDate: '31 may, 2021',
            chartOptions:{
                chart: {
                    type: 'column'
                },
                legend: {
                    enabled:false
                },
                credits: {
                    enabled: false
                },
                colors: ["#007AFF"], 
                title: {
                    text: ''
                },
                xAxis: {
                    gridLineWidth: 1,
                    categories: ['10 Sec', '20 Sec', '30 Sec', '40 Sec', '50 Sec', '60 Sec'],
                    lineColor:'#007AFF',     
                },
                plotOptions: {
                    series: {
                        borderWidth: 1,
                        borderColor: '#007AFF',
                        borderRadius:4,
                        pointWidth: 24,
                        dataLabels: {
                            enabled: true,
                            format: '{point.y}%',  
                             
                            color: 'Gray'             
                        }
                    },
                },
                yAxis: {
                    gridLineWidth: 1,
                    min: 0,
                    max:100,
                    title: {
                        text: ' '
                    },
                    labels: {
                        formatter: function() {
      return this.value + '%';
    }
                    }
                },          
                series: [{
                    name: 'Series 1',
                    data: [40,70,45,20,0,28],         
                    borderRadiusTopLeft: '20px',
                    borderRadiusTopRight: '20px',         
                    color: '#d1e7ff',
                    // lineColor:'#007AFF',                     
                }]
            },
        }
    }
    

}
</script>
<style scoped>
.form-control{
    height: unset !important;
    font-size: 12px;
}
.form-control:focus{
   border: none;
}
.btn-color{
  border-color: #D9DCE1;
  padding: 0px 1px
}
.dropdown-position-bottom.profileStrengthpop {
    z-index: 3 !important;
    color: rgba(31,31,31,1)  !important;
    font-size: 12px !important;
    top: 50px !important;
    font-weight: 500;
    width: 150px !important;
    left: unset !important;
    transform: translate3d(-35%,0px,0px);
  }
 .vue-popover.dropdown-position-bottom.profileStrengthpop:before {
    display: none !important;
  }
 .profhoriz {
  margin-top: .25em;
  margin-bottom: .25em;
  margin-left: 15px;
  margin-right: 15px;
  border-top: 1.5px solid rgba(0,0,0,.1);
  opacity:0.4
}
.hc{
    height: 220px;
    width: 100%;
    zoom: 1;
}
</style>
